import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import React, { Fragment, ReactNode } from "react";
import { Button } from "../atoms/Button";
import { classNames } from "@/shared/utils/classnames";

type DialogCreateProps = {
  children?: React.ReactNode;
  open: boolean | undefined;
  setOpen: (open: boolean) => void | undefined;
  tittle?: string;
  subTittle?: string;
  OnclickCreate?: () => void;
  OnclickCancel?: () => void;
  tittleButtonCreate?: string;
  tittleButtonCancel?: string;
  dialogWidth?: string;
  hideFooter?: boolean;
  isLoading?: boolean;
  acceptDisabled?: boolean;
  cancelDisabled?: boolean;
  footer?: ReactNode;
  onClose?: () => void; // Corregir el nombre de la propiedad
  onBack?: () => void;
  modalClassName?: string;
};

export const DialogCreate: React.FC<DialogCreateProps> = ({
  children,
  open,
  onClose, // Corregir el nombre de la propiedad
  setOpen,
  tittle,
  subTittle,
  onBack,
  tittleButtonCreate,
  tittleButtonCancel,
  OnclickCreate,
  OnclickCancel,
  dialogWidth = "",
  isLoading,
  acceptDisabled = false,
  cancelDisabled = false,
  hideFooter,
  footer,
  modalClassName,
}) => {
  return (
    <div>
      <Dialog
        open={open}
        onClose={() => {
          if (onClose) {
            onClose();
          }
          setOpen(false);
        }}
        className={classNames("relative z-10", modalClassName)}
      >
        <div className="fixed inset-0" />

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
              <DialogPanel
                transition
                className={`${dialogWidth}  pointer-events-auto w-screen max-w-2xl transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700`}
              >
                <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                  <div className="flex flex-col flex-1">
                    {/* Header */}
                    <div className="bg-gray-50 px-4 py-6 sm:px-6">
                      <div className="flex items-start justify-between space-x-3">
                        <div className="flex items-center gap-5">
                          {onBack && <Button text="Volver" onClick={onBack} />}
                          <div className="space-y-1">
                            <DialogTitle className="text-base font-semibold leading-6 text-gray-900">
                              {tittle}
                            </DialogTitle>
                            <p className="text-sm text-gray-500">{subTittle}</p>
                          </div>
                        </div>

                        <div className="flex h-7 items-center">
                          <button
                            type="button"
                            onClick={OnclickCancel}
                            className="relative text-gray-400 hover:text-gray-500"
                          >
                            <span className="absolute -inset-2.5" />
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Divider container */}
                    <div className="flex-grow flex-col flex space-y-6 py-6 sm:space-y-0 sm:divide-y sm:divide-gray-200 sm:py-0">
                      {children}
                    </div>
                  </div>

                  {footer ? (
                    <Fragment>
                      <div className="flex-shrink-0 border-t border-gray-200 px-4 py-5 sm:px-6">
                        {footer}
                      </div>
                    </Fragment>
                  ) : (
                    <Fragment>
                      {hideFooter ? (
                        <Fragment />
                      ) : (
                        <div className="flex-shrink-0 border-t border-gray-200 px-4 py-5 sm:px-6">
                          <div className="flex justify-end space-x-3">
                            <button
                              disabled={cancelDisabled}
                              type="button"
                              onClick={OnclickCancel}
                              className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                            >
                              {tittleButtonCancel}
                            </button>
                            {tittleButtonCreate && (
                              <button
                                type="button"
                                disabled={acceptDisabled}
                                onClick={OnclickCreate}
                                className="inline-flex gap-2 justify-center items-center rounded-md bg-black px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500"
                              >
                                {isLoading && (
                                  <div
                                    className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white"
                                    role="status"
                                  ></div>
                                )}
                                {tittleButtonCreate}
                              </button>
                            )}
                          </div>
                        </div>
                      )}
                    </Fragment>
                  )}
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};
